/*
  德语
*/
export default {
  headerBar: {
    allProducts: 'Alle Produkte',
    newIn: 'Neu in',
    bestSellers: 'Bestseller',
    specialOffer: 'Sonderangebot',
    explore: 'Erkunden',
    fashionTrends: 'Modetrends',
    whyUs: 'Warum wir',
    helpCenter: 'Help Center',
    company: 'Unternehmen',
    dropshipping: 'Drop Shipping',
    aboutUs: 'Über uns',
    blog: 'Blog',
    login: 'Login',
    register: 'Kostenlos registrieren',
    searchingFor: 'Suche nach',
    wishList: 'Wunschliste',
    listing: 'Auflistung',
    allOrder: 'Alle Reihenfolge',
    accountSetting: 'Kontoeinstellung',
    logOut: 'Abmelden',
    home: 'Home',
    startSelling: 'Verkauf beginnen',
    wholesale: 'Großhandel'
  },
  indexPage: {
    hello: 'Hallo',
    allCategory: 'Alle Kategorien',
    apparelWholesale: 'Bekleidung Großhandel',
    smartDropshiping: 'Intelligentes Dropshiping',
    smallMOQCustomization: 'Kleine MOQ Anpassung',
    fastWorldwideShipping: 'Schneller weltweiter Versand',
    estimateShippingCost: 'Geschätzte Versandkosten',
    flashSale: 'Flash Sale',
    customization: 'Anpassung',
    customizationText1: 'Mit 500+ Lieferanten und 100+ Designern,',
    customizationText2: 'Exklusive Produkte können NUR für Sie angepasst werden.',
    ins: "Influencer' Pick",
    insText1: 'Neueste Stile auf Modetrend Outfits inspo zu bekommen.',
    insText2: 'Dieselben Entwürfe zu passen und für Ihren Verkauf zu liefern.',
    youMayLike: 'Sie mögen vielleicht',
    viewMore: 'Mehr anzeigen'
  }
}
